
import {useParams} from 'react-router-dom'
import React, { useEffect, useState, useRef } from "react";
import Select from "react-select";
// reactstrap components
import {
  Button, InputGroup, InputGroupText, Spinner,
  Card,Badge, Modal, ModalBody, ModalHeader,
  CardHeader, 
  CardBody,
  CardFooter,
  CardTitle,
  FormGroup,
  Form,
  Input,
  Row,
  Col,
} from "reactstrap";
import ReactTable from "components/ReactTable/ReactTable.js";
import CreateVInfo from './CreateVInfon'
import Spin from '../../../assets/img/Spinner2.gif'
import { Rating } from 'react-simple-star-rating'
import swal from "sweetalert";
import {customStyles} from '../../../helpers/mycomps'


const months = [
  {value : 0, label : "Jan"},
  {value : 1, label : "Feb"},
  {value : 2, label : "Mar"},
  {value : 3, label : "April"},
  {value : 4, label : "May"},
  {value : 5, label : "June"},
  {value : 6, label : "July"},
  {value : 7, label : "Aug"},
  {value : 8, label : "Sept"},
  {value : 9, label : "Oct"},
  {value : 10, label : "Nov"},
  {value : 11, label : "Dec"}
]

const cats = [
   {value : 1 , categoryCode : "1" , label : "Cars"},
   {value : 2 , categoryCode : "2" , label : "Yachts"}, 
   {value : 3 , categoryCode : "3" , label : "Machines"}
]


function Lapprove(props) {
  let d = new Date()
  d.setDate(d.getDate() - 7);

    //const [tuid, setTuid] = useState({tuid : "2000"})
    const [showProcessing, setShowProcessing] = useState(false)
    const [tlisting, setListing] = useState([])
       
    const [infom, setInfom] = useState(false)

    const SpinnerNew = <div className="spoverlay"><center><img style={{marginTop : 200}} src={Spin} alt="a" width={"200px"}/><h4>Please wait...</h4></center></div>
    const [vehicle , setVehicle ] = useState({
        vid : "",
        luid : "",
        tluid: "",
        tuid : "",
        listingtype : "",
        categoryCode : "", 
        category : {en : "", fr : "", ar : ""},
        bid : "",
        blogo : "",
        bname :   {en : "", fr : "", ar : ""},
        mname :  {en : "", fr : "", ar : ""},
        modelyear : {value : "", label :""},
        notes : "",
        vtypeCode : "",
        vtname : {en : "", fr : "", ar : ""},
        features: [{featureCode : "", en : "", fr : "", ar : "", unit : "", rangeid : "" , rangevalueL : "" , rangevalueH: ""}],
        insurence : true,
        intcolor  : "",
        extcolor : "",
        approxmiles : "",
        daily : {amt : "", mileq : "", xmileq : "", wdamt : ""},
        fdaily : {amt : "", mileq : "", xmileq : "", wdamt : ""},
        weekly : {amt : "", mileq : "", xmileq : "", wdamt : ""},
        fweekly : {amt : "", mileq : "", xmileq : "", wdamt : ""},
        monthly : {amt : "", mileq : "", xmileq : "", wdamt : ""},
        fmonthly : {amt : "", mileq : "", xmileq : "", wdamt : ""},
        fuelCode : "",
        fuelName  : {en :"", fr : "", ar: ""},
        trmCode : "",
        trmName : {en : "", fr : "", ar : ""}
      })
     
      

    const tenlisting = () => {
        
        setShowProcessing(true)
        props.API.get(`tenant/tlisting`, { headers :{"arixauth" : localStorage.getItem("arixauth")}}).then((res) => {
            //  basicAlert(res.data.message)
              setShowProcessing(false)
              
              let data = res.data.data.map((g, key) => {
                
                return {
                    key : key,
                    cLogo : g.tenant.cLogo,
                    mngName : g.tenant.mngName,
                    cellNumber : g.tenant.cellNumber,
                    managerid : g.tenant.managerid,
                    city : g.tenant.city,
                    tuid : g.tuid , 
                    luid : g.luid,
                    tluid: g.tluid,
                    category  : g.category,
                    bname : g.bname,
                    mname : g.mname,
                    modelyear : g.modelyear,
                    vtname : g.vtname,
                    notes : g.notes,
                    daily : g.daily,
                    imgmc : g.imgmc,
                    fdaily : g.fdaily,
                    lrating : g.lrating,
                    listingStatus : g.listingStatus ? "Listed"  : "Awaiting" ,
                    actions:(  <div>
                              <Rating
                                   onClick={f => {
                                    let obj = data.find((o) => o.key === key);
                                    

                                    handleRating(obj.tuid, obj.tluid, f)
                                }}
                                initialValue={g.lrating}
                                size = "20"
                                allowFraction	
                                 />
                        </div>),
            
                }
              })
               
              
              setListing(data)
            }).catch(function (error) {
                console.log(error)
              setShowProcessing(false)
              if(error){
                props.swal("Error handling request, refresh page.")
              }
            }) 
    }


    useEffect(() => {
        tenlisting()
        
    },[])



    const displayl = () => {
        try{
          return (
           <>
            <Card>
                   
                   <CardBody >
                         <ReactTable 
                           data= {tlisting}
                           columns={[
                             {
                                 Header: "img",
                                 accessor: d =>  <center><img alt="..." width={"100px"} src={`${d.imgmc}`} style={{ cursor : "pointer"}} onClick={t => imgclick(d)}/> </center>,
                               },
                               {
                                   Header: "Tenant-List",
                                   accessor: d =>  d.tluid,
                                 },
                             {
                               Header: "C.Name",
                               accessor: d =>  d.category.en + " " + d.category.ar ,
                             },
                            
                             {
                               Header: "Brand",
                               accessor: d => d.bname.en + " " + d.bname.ar,
                             },
                             {
                                 Header: "Model",
                                 accessor: d =>  d.mname.en + " " + d.mname.ar,
                               },
                               {
                                   Header: "Year",
                                   accessor: d =>  d.modelyear.label ,
                                 },
                                 {
                                   Header: "Type",
                                   accessor: d =>  d.vtname.en ,
                                 },
                                 {
                                   Header: "Specs",
                                   accessor: d =>  d.notes ,
                                 },
                              
       
                           {
                                   Header: "Daily",
                                   accessor: d =>  <span>{d.daily.amt} /  <span style={{color: "green"}}>{d.fdaily.amt}</span></span>,
                           },
                                {
                                    Header: "Status",
                                    accessor: d =>  d.listingStatus === "Listed" ? <Badge color="primary" style={{cursor : "pointer"}} onClick={x => edlisting(d)}>Listed</Badge> : <Badge color="danger" onClick={x => edlisting(d)} style={{cursor : "pointer"}}>Awaiting...</Badge>,
                                    },
                             {
                               Header: "Rating",
                               accessor: d => d.actions,
                               sortable: false,
                               filterable: false,
                             },
                           ]}
                           /*
                               You can choose between primary-pagination, info-pagination, success-pagination, warning-pagination, danger-pagination or none - which will make the pagination buttons gray
                             */
                           className="-striped -highlight primary-pagination"
                         />
                       </CardBody>
                    
             </Card>
             </>
          )  
        }catch(e){
            
            return (
                <h6>No listing for this tenant exist.</h6>
            )
            
        }
    }

    const handleRating = (tuid, f , rate) => {
        setShowProcessing(true)
        
    
            props.API.get(`tenant/edlistingrateal/${tuid}/${f}/${rate}`,{ headers :{"arixauth" : localStorage.getItem("arixauth")}}).then((res) => {
                let data = res.data.data.map((g, key) => {
                
                    return {
                      key : key,
                      cLogo : g.tenant.cLogo,
                      mngName : g.tenant.mngName,
                      cellNumber : g.tenant.cellNumber,
                      managerid : g.tenant.managerid,
                      city : g.tenant.city,
                      tuid : g.tuid , 
                      luid : g.luid,
                      tluid: g.tluid,
                      category  : g.category,
                      bname : g.bname,
                      mname : g.mname,
                      modelyear : g.modelyear,
                      vtname : g.vtname,
                      notes : g.notes,
                      daily : g.daily,
                      imgmc : g.imgmc,
                      fdaily : g.fdaily,
                      lrating : g.lrating,
                      listingStatus : g.listingStatus ? "Listed"  : "Awaiting" ,
                        actions:(  <div>
                                  <Rating
                                       onClick={f => {
                                        let obj = data.find((o) => o.key === key);
                                        handleRating(obj.tuid, obj.tluid, f)
                                    }}
                                    size = "20"
                                    allowFraction	
                                    initialValue={g.lrating}
                                     />
                            </div>),
                
                    }
                  })
                setListing(data)
            setShowProcessing(false)
         
          }).catch(function (error) {
            setShowProcessing(false)
            if(error.response.status === 401){
              props.swal("Unauthorized, please login again.").then(t => {
                  props.history.push(`/auth/login`)
              })   
            }else{
              swal("Error setting listing rating")
            }
             
          }) 

       // setRating(rate)
       
        // other logic
      }

      const edlisting = (e) => {
        console.log("editing listing")
        let tuid = e.tuid
        let tluid = e.tluid
        let invStatus = e.listingStatus === "Listed" ? false : true
        setShowProcessing(true)
            props.API.get(`tenant/edlistingal/${tuid}/${tluid}/${invStatus}`,{ headers :{"arixauth" : localStorage.getItem("arixauth")}}).then((res) => {
                let data = res.data.data.map((g, key) => {
                console.log("listing edited")
                    return {
                        key : key,
                        cLogo : g.tenant.cLogo,
                        mngName : g.tenant.mngName,
                        cellNumber : g.tenant.cellNumber,
                        managerid : g.tenant.managerid,
                        city : g.tenant.city,
                        tuid : g.tuid , 
                        luid : g.luid,
                        tluid: g.tluid,
                        category  : g.category,
                        bname : g.bname,
                        mname : g.mname,
                        modelyear : g.modelyear,
                        vtname : g.vtname,
                        notes : g.notes,
                        daily : g.daily,
                        fdaily : g.fdaily,
                        lrating : g.lrating,
                        imgmc : g.imgmc,
                        listingStatus : g.listingStatus ? "Listed"  : "Awaiting" ,
                        actions:(  <div>
                                  <Rating
                                       onClick={f => {
                                        let obj = data.find((o) => o.key === key);
                                        handleRating(obj.tuid, obj.tluid, f)
                                    }}
                                    size = "20"
                                    allowFraction	
                                    initialValue={g.lrating}
                                     />
                            </div>),
                
                    }
                  })
                setListing(data)
            setShowProcessing(false)
         
          }).catch(function (error) {
            setShowProcessing(false)
            if(error.response.status === 401){
              props.swal("Unauthorized, please login again.").then(t => {
                  props.history.push(`/auth/login`)
              })   
            }else{
              swal("Error setting listing rating")
            }
             
          }) 
      }

     const imgclick = (tluid) => {
      
        setInfom(true)
        setVehicle(tluid)

     } 
  
  

    return (
        
        <div className='content'>
           <CreateVInfo vehicle={vehicle} setInfom={setInfom} infom={infom} API={props.API}/>
            {showProcessing && SpinnerNew}
            {displayl()}
          
        </div>
    );
}

export default Lapprove;